var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1061_3143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0312 19.7812H28.4062C28.5969 19.7812 28.7797 19.857 28.9145 19.9918C29.0493 20.1266 29.125 20.3094 29.125 20.5C29.125 20.6906 29.0493 20.8734 28.9145 21.0082C28.7797 21.143 28.5969 21.2188 28.4062 21.2188H14.0312C13.8406 21.2188 13.6578 21.143 13.523 21.0082C13.3882 20.8734 13.3125 20.6906 13.3125 20.5C13.3125 20.3094 13.3882 20.1266 13.523 19.9918C13.6578 19.857 13.8406 19.7812 14.0312 19.7812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3289 20.5004L20.2902 26.4603C20.4252 26.5953 20.501 26.7783 20.501 26.9692C20.501 27.16 20.4252 27.3431 20.2902 27.478C20.1552 27.613 19.9722 27.6888 19.7813 27.6888C19.5904 27.6888 19.4074 27.613 19.2724 27.478L12.8037 21.0093C12.7368 20.9425 12.6836 20.8632 12.6474 20.7759C12.6112 20.6886 12.5925 20.595 12.5925 20.5004C12.5925 20.4059 12.6112 20.3123 12.6474 20.2249C12.6836 20.1376 12.7368 20.0583 12.8037 19.9915L19.2724 13.5228C19.4074 13.3878 19.5904 13.312 19.7813 13.312C19.9722 13.312 20.1552 13.3878 20.2902 13.5228C20.4252 13.6578 20.501 13.8408 20.501 14.0317C20.501 14.2225 20.4252 14.4056 20.2902 14.5405L14.3289 20.5004Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1061_3143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0ebc4918f33127e01932c0c4be0f48da.svg";
export { ForwardRef as ReactComponent };